module.exports = __webpack_public_path__ + "media/images/client_footer__background--desktopLargeUp-41cfc37a80c0c0efa353ec980b9b2580.png";